import React, { Suspense } from 'react';
import { SurveyJSLoadingSpinner } from '../../_lib/SurveyJS/partials/SurveyJSLoadingSpinner';

const SurveyBlock = React.lazy(() => import(/* webpackChunkName: "SurveyBlock" */ './SurveyBlock'));

/**
 * Lazy load the whole Survey Block, this will split any imports from survey into an own bundle and lazy load on demand.
 */
export function LazyLoadSurveyBlock(props: any) {
  return (
    <Suspense fallback={<SurveyJSLoadingSpinner />}>
      <SurveyBlock {...props} />
    </Suspense>
  );
}
